import React, { Component } from 'react';
import toast from '@util/toast';
export const WithBaiduMediaUpload = (store?: any) => {
    const BosClient = window['baidubce']['sdk']['BosClient'];
    const VodClient = window['baidubce']['sdk']['VodClient'];
    return (ComponentCon) => {
        class MediaUploadHoc extends Component<any, any> {
            public videoUploader: any;
            public aliyunHost: any;
            public client: any;
            public timer: any;
            public count: number = 0; // 统计图片上传队列
            constructor(props) {
                super(props);
                this.multipartUpload.bind(this);
                this.state = {
                    errorStatus: true,
                    errorContent: '',
                };
            }
            // 获取视频数据信息
            public getPlayInfo = (videoID) => {
                // 已废弃
                return new Promise((resolve, reject) => {
                    this.props.store.playInfo
                        .init(videoID)
                        .then((res) => {
                            console.log('获取视频数据成功', res);
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            };
            // 获取视频封面图
            public getSnapshots(videoId) {
                // 已废弃
                return new Promise((resolve, reject) => {
                    this.props.store.snapshots
                        .init(videoId)
                        .then((res) => {
                            console.log('获取封面图成功', res);
                            resolve(res);
                        })
                        .catch((err) => {
                            console.log('获取封面图失败', err);
                            reject(err);
                        });
                });
            }
            // 获取视频上传临时权限
            // tslint:disable-next-line:ban-types uploadType new:不等转码
            public getStsUpload = (target: any, fn: Function, uploadType: string) => {
                this.setState({
                    errorStatus: false,
                    errorContent: '视频正在上传处理中',
                });
                this.props.store.stsUpload
                    .init()
                    .then((res) => {
                        console.log('获取视频上传临时权限成功', res);
                        this.aliyunHost = res.host;
                        const ossParam = {
                            target,
                            sessionToken: res.securityToken,
                            endpoint: res.endpoint,
                            bucketName: res.bucketName,
                            credentials: {
                                ak: res.accessKeyId,
                                sk: res.accessKeySecret,
                            },
                        };

                        console.log('-----ossParam----', ossParam);
                        this.createVideoVodUpload(target, ossParam, fn, uploadType);
                    })
                    .catch((err) => {
                        console.log('获取视频上传临时权限失败', err);
                        // alert('视频上传失败');
                        this.setState({
                            errorStatus: true,
                        });
                        toast.error('视频上传失败');
                    });
            };
            // uploadType :new 不等转码
            public async createVideoVodUpload(file, STSTokenObj, fn, uploadType) {
                const _self = this;
                this.setState({
                    errorStatus: false,
                    errorContent: '视频正在上传处理中',
                });
                const config = {
                    sessionToken: STSTokenObj.sessionToken,
                    credentials: STSTokenObj.credentials,
                    // endpoint: STSTokenObj.endpoint,
                    endpoint: 'https://vod.bj.baidubce.com',
                };
                this.videoUploader = new VodClient(config);
                const flag = file.size / 1024 / 1024 > 6;
                this.videoUploader.on('progress', (res) => {
                    if (flag) {
                        if (res.lengthComputable && (!res.timeStamp)) {
                            this.props.store.createVideoState.set_videoSize(res.total);
                            this.props.store.createVideoState.set_loaded(res.loaded);
                            this.props.store.createVideoState.set_progress((res.loaded * 100 / res.total).toFixed(2));
                        }
                    }
                    if (!flag) {
                        this.props.store.createVideoState.set_videoSize((res.total / 1024 / 1024).toFixed(2));
                        this.props.store.createVideoState.set_loaded((res.loaded / 1024 / 1024).toFixed(2));
                        this.props.store.createVideoState.set_progress((res.loaded * 100 / res.total).toFixed(2));
                    }
                });
                this.videoUploader
                    .createMediaResource(file.name, '视频上传', file)
                    .then((response) => {
                        console.log('视频上传成功', response);
                        // // 上传完成
                        this.timer = setInterval(() => {
                            this.videoUploader
                                .getMediaResource(response.body.mediaId)
                                .then((getMedia) => {
                                    if (uploadType === 'new') {
                                        console.log('查询视频转码状态', getMedia);
                                        clearInterval(this.timer);

                                        if ( getMedia.body && getMedia.body.playableUrlList && getMedia.body.playableUrlList[0] && getMedia.body.playableUrlList[0].url) {
                                            this.setState({
                                                errorStatus: true,
                                            });
                                            fn(getMedia);
                                        }
                                        return;
                                    }
                                    // 查询成功
                                    if (getMedia.body.status === 'PUBLISHED') {
                                        // 转码完成
                                        clearInterval(this.timer);
                                        this.videoUploader
                                            .getPlayableUrl(
                                                response.body.mediaId
                                            )
                                            .then((playUrl) => {
                                                console.log(playUrl);
                                                const uploadInfo: any = {};
                                                uploadInfo.duration =
                                                    playUrl.body.duration;
                                                uploadInfo.videoId =
                                                    response.body.mediaId;
                                                uploadInfo.snapshots = [
                                                    playUrl.body.cover,
                                                ];
                                                uploadInfo.PlayInfo = [
                                                    {
                                                        playURL:
                                                        playUrl.body.file,
                                                    },
                                                ];
                                                this.props.store.getBosImgInfoModel
                                                    .init(playUrl.body.cover)
                                                    .then((imgRes) => {
                                                        this.setState({
                                                            errorStatus: true,
                                                        });
                                                        console.log('图片信息', imgRes);
                                                        uploadInfo.pixel =
                                                            imgRes.imageWidth
                                                                .value +
                                                            '*' +
                                                            imgRes.imageHeight
                                                                .value;
                                                        fn(uploadInfo);
                                                        clearInterval(
                                                            this.timer
                                                        );
                                                    })
                                                    .catch((err) => {
                                                        this.setState({
                                                            errorStatus: true,
                                                        });
                                                        uploadInfo.pixel =
                                                            err.imageWidth
                                                                .value +
                                                            '*' +
                                                            err.imageHeight
                                                                .value;
                                                        fn(uploadInfo);
                                                        clearInterval(
                                                            this.timer
                                                        );
                                                    });
                                            });
                                    } else if (
                                        getMedia.body.status !== 'RUNNING'
                                    ) {
                                        clearInterval(this.timer);
                                        this.setState({
                                            errorStatus: true,
                                        });
                                        toast.error('视频上传转码失败');
                                    }
                                })
                                .catch((error) => {
                                    console.log(error);
                                    // 查询错误
                                    this.setState({
                                        errorStatus: true,
                                    });
                                    toast.error('视频上传失败');
                                });
                        }, 2000);
                    })
                    .catch((error) => {
                        // 上传错误
                        console.log(2222, error);
                        this.setState({
                            errorStatus: true,
                        });
                        toast.error('视频上传失败');
                    });
            }
            // 获取图片上传临时权限
            public getStsWrite = (target: any, fn: any) => {
                this.count++;
                this.setState({
                    errorStatus: false,
                    errorContent: '图片正在上传处理中',
                });
                this.props.store.stsWrite
                    .init()
                    .then((res) => {
                        console.log('获取百度临时图片上传写的权限成功', res, target);
                        this.aliyunHost = res.host;
                        const ossParam = {
                            target,
                            securityToken: res.securityToken,
                            endpoint: res.endpoint,
                            bucketName: res.bucketName,
                            credentials: {
                                ak: res.accessKeyId,
                                sk: res.accessKeySecret,
                            },
                        };
                        this.checkOss(ossParam, fn, res.folderPrefix);
                    })
                    .catch((err) => {
                        console.log('获取临时图片上传写的权限失败', err);
                        this.count--;
                        if (this.count <= 0) {
                            this.setState({
                                errorStatus: true,
                            });
                        }
                        /* this.setState({
                        errorStatus: true,
                    }); */
                        // alert('图片上传失败');
                        toast.error('图片上传失败');
                    });
            };
            public getStsRead = (file) => {
              return this.props.store.StsRead
              .init(file)
              .then((readRes) => {
                console.log('获取百度临时图片读的权限成功', readRes);
                return readRes;
              });
            }
            public checkOss = (ossParam, fn, folderPrefix) => {
                this.client = new BosClient({
                    credentials: ossParam.credentials,
                    sessionToken: ossParam.securityToken,
                    endpoint: ossParam.endpoint,
                });
                this.multipartUpload(ossParam.target, ossParam.bucketName, fn, folderPrefix);
            };
            public async multipartUpload(file, bucketName, fn, folderPrefix) {
                try {
                    const fileName = file.name;
                    const lastDotIndex = fileName.lastIndexOf('.');
                    const randomValue =
                        new Date().getTime().toString().substr(4) +
                        (Math.random() * 1000000).toFixed(0);
                    const filekey = `${randomValue}.${fileName.substr(
                      lastDotIndex + 1
                  )}`;
                    const newFileName = `${folderPrefix}/lixiangzhizao_app/pc_push_system/${filekey}`;
                    const result = await this.client.putObject(
                        bucketName,
                        newFileName,
                        file,
                        {
                            headers: {
                                'Content-Disposition': `attachment; filename=${encodeURIComponent(
                                    file.name
                                )}`,
                            },
                            mime: 'image/jpeg',
                        }
                    );
                    // if (
                    //     this.aliyunHost.substr(this.aliyunHost.length - 1) !==
                    //     '/'
                    // ) {
                    //     this.aliyunHost = this.aliyunHost + '/';
                    // }
                    // result.url = this.aliyunHost + newFileName;
                    const oasReadFile = await this.getStsRead(newFileName);
                    this.props.store.getOasBosImgInfoModel
                        .init(newFileName)
                        .then((res) => {
                            this.count--;
                            if (this.count <= 0) {
                                this.setState({
                                    errorStatus: true,
                                });
                            }
                            console.log('图片信息', res, oasReadFile);
                            oasReadFile.pixel =
                                res.data.imageWidth.value +
                                '*' +
                                res.data.imageHeight.value;
                            oasReadFile.url = oasReadFile.fileUrl;
                            fn(oasReadFile);
                        })
                        .catch((err) => {
                            console.log(
                                '获取图片信息失败====>',
                                err,
                                this.count
                            );
                            this.count--;
                            if (this.count <= 0) {
                                this.setState({
                                    errorStatus: true,
                                });
                            }
                            if (err.data && err.data.imageWidth) {
                              oasReadFile.pixel =
                                    err.data.imageWidth.value +
                                    '*' +
                                    err.data.imageHeight.value;
                              oasReadFile.url = oasReadFile.fileUrl;
                            }
                            fn(oasReadFile);
                        });
                } catch (e) {
                    console.log('上传出错', e);
                    // alert('图片上传失败');
                    toast.error('图片上传失败');
                    this.setState({
                        errorStatus: true,
                    });
                }
            }
            public componentDidMount() {
                console.log('MediaUploadHoc');
            }
            public componentWillUnmount() {
                clearInterval(this.timer);
            }
            public render() {
                const newProps = {
                    getStsWrite: this.getStsWrite,
                    getStsRead: this.getStsRead,
                    getStsUpload: this.getStsUpload,
                    ...this.props,
                    ...this.state,
                };
                return <ComponentCon {...newProps} />;
            }
        }
        return store ? store(MediaUploadHoc) : MediaUploadHoc;
    };
};
